<template>
<div>
    <v-card flat color="transparent" class="mt-7">
        <v-toolbar  class="bdr secondary2light" :elevation="0" outlined>
            <v-toolbar-title>{{$t('notes')}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- <v-btn
                icon
                large
            >
                <v-icon>mdi-pencil-outline</v-icon>
            </v-btn> -->
            <v-tooltip top color="black">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        outlined
                        small
                        @click="showAddNote = true"
                        class="mr-2"
                    >
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </template>
                <span>{{$t('animal.addNote')}}</span>
            </v-tooltip>
        </v-toolbar>
    </v-card>
    <v-card flat class="mt-7" min-height="600">
        <v-card-text>
            <notes :key="times"/>
        </v-card-text>
    </v-card>
    <add-note v-on:note:added="noteAdded" v-if="showAddNote" :dialogI="showAddNote" @closeAddDept="showAddNote = false"></add-note>
</div>
</template>
<script>
import Notes from './notes/NotesList.vue'
import AddNote from './notes/AddNote.vue'

export default {
    components: {
        Notes,
        AddNote
    },
    data() {
        return {
            tab: null,
            showAddNote: false,
            times: 0
        }
    },

    methods: {
        noteAdded(success) {
            if(success){
                this.times+=1
                this.showAddNote = false
            }
        }
     }
}
</script>
<style lang="scss" scoped>
.bdr {
    border: thin solid $secondary-color;
}
</style>